import en from './en';
import bs from './bs';
import hr from './hr';
import sr from './sr';

const translations = {
  en, bs, hr, sr,
};
const loadTranslations = (lang) => translations[lang];

export {
  loadTranslations, en, bs, hr, sr,
};
